import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabaseClient';
import {
  PORTONE_DUMMY_PHONE,
  consumeSleepCareCheckoutPending,
  finalizeSleepCarePaymentSuccess,
} from '../../config/sleepCareCheckout';

/**
 * PortOne 결제 redirectUrl 로 복귀하는 전용 URL.
 * 쿼리: paymentId, customerName, customerEmail, customerPhone (home에서 넘긴 값)
 */
export default function SleepCareCheckout() {
  const navigate = useNavigate();
  const [phase, setPhase] = useState('processing');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paymentId = params.get('paymentId') || params.get('payment_id');
    const code = params.get('code');

    if (!paymentId) {
      setPhase('noop');
      return;
    }

    const doneKey = `sc_pay_${paymentId}`;
    if (sessionStorage.getItem(doneKey)) {
      window.history.replaceState({}, document.title, window.location.pathname);
      navigate('/payments', { replace: true });
      return;
    }

    const lockKey = `sc_lock_${paymentId}`;
    if (sessionStorage.getItem(lockKey)) {
      setPhase('busy');
      return;
    }
    sessionStorage.setItem(lockKey, '1');

    if (code) {
      sessionStorage.removeItem(lockKey);
      consumeSleepCareCheckoutPending();
      alert(`결제 실패: ${params.get('message') || '결제에 실패했습니다.'}`);
      window.history.replaceState({}, document.title, window.location.pathname);
      setPhase('failed');
      return;
    }

    (async () => {
      try {
        const customerName = params.get('customerName') || '';
        const customerEmail = params.get('customerEmail') || '';
        const customerPhone = params.get('customerPhone') || PORTONE_DUMMY_PHONE;
        const {
          data: { session },
        } = await supabase.auth.getSession();
        const authUserId = session?.user?.id ?? null;

        const pending = consumeSleepCareCheckoutPending() || {};
        const totalAmount = pending.totalAmount ?? pending.total_amount;

        const result = await finalizeSleepCarePaymentSuccess({
          paymentId,
          customerName,
          customerEmail,
          customerPhone,
          authUserId,
          totalAmount,
        });

        window.history.replaceState({}, document.title, window.location.pathname);

        if (result.success) {
          sessionStorage.setItem(doneKey, '1');
          sessionStorage.removeItem(lockKey);
          alert('결제가 완료되었습니다.');
          navigate('/payments');
        } else {
          sessionStorage.removeItem(lockKey);
          alert(result.message || '결제 확인에 실패했습니다.');
          setPhase('failed');
        }
      } catch (e) {
        console.error(e);
        sessionStorage.removeItem(lockKey);
        alert('결제 확인 중 오류가 발생했습니다.');
        setPhase('failed');
      }
    })();
  }, [navigate]);

  if (phase === 'noop') {
    return (
      <div style={{ padding: 24, fontFamily: 'system-ui' }}>
        <p>잘못된 접근입니다.</p>
        <button type="button" onClick={() => navigate('/')}>
          홈으로
        </button>
      </div>
    );
  }

  return (
    <div style={{ padding: 48, textAlign: 'center', fontFamily: 'system-ui' }}>
      <p>결제 결과를 확인하는 중입니다…</p>
    </div>
  );
}
